// ConditionalMapsApiProvider — wraps the Google Maps APIProvider with an
// online-state gate.
import { APIProvider } from "@vis.gl/react-google-maps";
import { InternetStatusContext } from "hhn-commons";
import { ReactNode, useContext } from "react";
import config from "../utils/Config";

interface ConditionalMapsApiProviderProps {
  children: ReactNode;
  offlineFallback?: ReactNode;
}

export function ConditionalMapsApiProvider({
  children,
  offlineFallback = null,
}: ConditionalMapsApiProviderProps) {
  const { isConnected } = useContext(InternetStatusContext);

  if (!isConnected) {
    return <>{offlineFallback}</>;
  }

  return (
    <APIProvider apiKey={config.googleMapKey ?? ""}>{children}</APIProvider>
  );
}
